import * as React from 'react';
import { ButtonModifier } from '../../../infrastructure/helpers';
import DefaultButton from '../default-button/default-button';
import Text from '../text/text';
import { ISingleSelectButtonProps, ISingleSelectClosedPropsDerivedFromItemsList, makeSingleSelectInPopover } from './make-single-select-in-popover';
import classNames from 'classnames';

/**
 * Render DefaultButton, with label, selectable through the SingleSelectList rendered in popover
 * change button look and feel based on popover being shown/hidden
 */
const SingleSelectButton = makeSingleSelectInPopover(
    React.forwardRef((props: ISingleSelectClosedPropsDerivedFromItemsList & ISingleSelectButtonProps, ref: React.Ref<HTMLInputElement>) => {
        const modifiers: ButtonModifier[] = ['fat'];

        if (props.isOpen) {
            modifiers.push('confirm-safe');
        } else {
            modifiers.push('options');
        }

        return (
            props.className
                ? <button
                        type='button'
                        className={classNames(props.className, {'active': props.isOpen})}
                        ref={ref}
                        onClick={() => props.isOpen ? props.onClick?.() : undefined}
                    >
                        <Text message={props.name} withEllipsis />
                    </button>
                : <DefaultButton modifier={modifiers} text={props.name} ref={ref} />);
    })
);

export { makeSingleSelectInPopover, SingleSelectButton };
